import type { ZudokuConfig } from "zudoku";
import { LanguageSwitcher } from "./src/LanguageSwitcher";

const config: ZudokuConfig = {
  site: {
    title: "Documentation",
    logo: {
      src: { light: "/logo.png", dark: "/logo.png" },
      alt: "Launify",
      width: "120px",
    },
  },
  metadata: {
    title: "Launify Address API",
    description:
      "Highly accurate, low-latency address typeahead and reverse geocoding.",
  },
  // Language dropdown in the header (next to the theme toggle).
  slots: {
    "head-navigation-start": <LanguageSwitcher />,
  },
  navigation: [
    // English — visible top-nav tabs. First tab is "REST API".
    {
      type: "category",
      label: "REST API",
      icon: "sparkles",
      items: ["/introduction", "/authentication"],
    },
    {
      type: "category",
      label: "API reference",
      icon: "folder-cog",
      collapsed: false,
      items: [
        "/endpoints/search",
        "/endpoints/structured",
        "/endpoints/geocode",
      ],
    },
    {
      type: "category",
      label: "Reference",
      icon: "book",
      items: ["/errors"],
    },
    // Čeština — hidden from the top-nav (the language dropdown switches locale);
    // these subtrees still drive the sidebar for "/cs/*".
    {
      type: "category",
      label: "REST API",
      icon: "sparkles",
      display: "hide",
      items: ["/cs/introduction", "/cs/authentication"],
    },
    {
      type: "category",
      label: "API reference",
      icon: "folder-cog",
      collapsed: false,
      display: "hide",
      items: [
        "/cs/endpoints/search",
        "/cs/endpoints/structured",
        "/cs/endpoints/geocode",
      ],
    },
    {
      type: "category",
      label: "Reference",
      icon: "book",
      display: "hide",
      items: ["/cs/errors"],
    },
  ],
  redirects: [{ from: "/", to: "/introduction" }],
};

export default config;
